module.exports = __webpack_public_path__ + "img/4.2142b425.png";